// hotpoints 
'use strict';

// int globali
window.slidePositionVieved = window.slidePositionVieved || {};
window.statElementCollector = window.statElementCollector || {};

document.querySelectorAll('.hotpoints--poi').forEach(el => {
	const left = parseFloat(el.getAttribute('data-left'));
	const top = parseFloat(el.getAttribute('data-top'));
	if (!isNaN(left) && !isNaN(top)) {
		el.style.left = left + '%';
		el.style.top = top + '%';
	}
});

// int statów
(function initHotpointsStats() {
	var containers = document.querySelectorAll('.hotpoints');
	for (var i = 0; i < containers.length; i++) {
		var cont = containers[i];
		var ga360id = cont.getAttribute('data-ga360-id');
		var wrapper = cont.closest('.__js_stats_wrapper');
		var artID = wrapper ? wrapper.getAttribute('data-id') : undefined;

		if (!ga360id) {
			// brak ga360-id
			console.log(
				'%c dodać ga360-id do hotpointa: ' + (cont.getAttribute('data-id') || ''),
				'background: #553311; padding: 3px; color: #ffaaaa'
			);
			continue;
		}

		window.statElementCollector[ga360id + '-' + artID] = {
			id: ga360id,
			moduleName: cont.getAttribute('data-id'),
			viewedCount: 0,
			itemCount: cont.querySelectorAll('.hotpoints--poi').length
		};

		// reset pozycji
		window.slidePositionVieved[ga360id + '-' + artID] = {};
	}
})();

// index elementu
function siblingIndex(el) {
	var i = 0;
	while (el && (el = el.previousElementSibling) !== null) i++;
	return i;
}

// klik na POI
function onPoiClick(ev) {
	if (window.isScrolling) return;

	var poi = ev.currentTarget;

	// zdjęcie hover
	var allHoverables = document.querySelectorAll('.hotpoints--poi, .hotpoints--poi-txt');
	for (var k = 0; k < allHoverables.length; k++) {
		allHoverables[k].classList.remove('hover');
	}

	// nadanie hover na aktywny
	poi.classList.add('hover');
	var ownTxt = poi.querySelector('.hotpoints--poi-txt');
	if (ownTxt) ownTxt.classList.add('hover');

	// i aktywny mobile
	var container = poi.closest('.hotpoints');
	var active = siblingIndex(poi);
	if (container) {
		var mobileTxts = container.querySelectorAll('.hotpoints--desc-mobile .hotpoints--poi-txt');
		if (mobileTxts[active]) mobileTxts[active].classList.add('hover');
	}

	// statystyki dla kliknięcia
	var wrapper = poi.closest('.__js_stats_wrapper');
	var artID = wrapper ? wrapper.getAttribute('data-id') : undefined;
	var galID = container ? container.getAttribute('data-id') : undefined;
	var ga360id = container ? container.getAttribute('data-ga360-id') : undefined;

	if (!ga360id) {
		// eslint-disable-next-line no-console
		console.log(
			'%c dodać ga360-id do hotpointa! ' + (galID || ''),
			'background: #3b3b3b; padding: 3px; color: #beeb2f'
		);
		return;
	}

	var key = ga360id + '-' + artID;
	if (!window.slidePositionVieved[key]) window.slidePositionVieved[key] = {};
	window.slidePositionVieved[key][active] = 1;

	if (window.statElementCollector[key]) {
		window.statElementCollector[key].viewedCount = Object.keys(window.slidePositionVieved[key]).length;
	}

	if (typeof window.sendStats === 'function') {
		window.sendStats('gallery', 'hotpoints', (artID || '') + ' / ' + (galID || ''), active);
	}

	if (!window.isScrolligFlag && window.WP && window.WP.pwp && typeof window.WP.pwp.customAction === 'function') {

		window.dataLayer.push({
			event: 'content_interaction',
			eventCategory: ga360id,
			moduleName: galID,
			eventAction: window.deviceTouch ? 'tap' : 'click'
		});
	}
}

// klik  w close
function onCloseClick(ev) {
	ev.stopPropagation();
	var allHoverables = document.querySelectorAll('.hotpoints--poi, .hotpoints--poi-txt');
	for (var i = 0; i < allHoverables.length; i++) {
		allHoverables[i].classList.remove('hover');
	}
}

// podpinanie handlerów
(function attachHotpointsHandlers() {
	var pois = document.querySelectorAll('.hotpoints--poi');
	for (var i = 0; i < pois.length; i++) {
		pois[i].addEventListener('click', onPoiClick);
	}

	var closes = document.querySelectorAll('.hotpoints--close');
	for (var j = 0; j < closes.length; j++) {
		closes[j].addEventListener('click', onCloseClick);
	}
})();
